import {AssetValuation} from "./asset-valuation";
import {AssetValuationScenario} from "./asset-valuation-scenario";

export type ValuationInput = "CF" | "MULTIPLE";
export type GpQuality = "LOW" | "MEDIUM" | "HIGH";
export type ConfidenceZone = "WITHIN_RANGE" | "NEAR_EDGE" | "OUTSIDE_RANGE";

export interface DiscountMultipleValuation {
    assetValuation: AssetValuation;
    scenarios: Array<AssetValuationScenario>;
    valuationInput: ValuationInput;
    gpQuality?: GpQuality;
    confidenceZone?: ConfidenceZone;
}

export const isValidValuationInput = (value: string): value is ValuationInput => ["CF", "MULTIPLE"].includes(value);
export const isGpQuality = (value?: string): value is GpQuality => !!value && ["LOW", "MEDIUM", "HIGH"].includes(value);

export interface RequiredDMVAlgoFields {
    totalTVPI: number | null;
    investmentDate: string | null;
    generalPartnerQuality: string | null
}
